<script setup>
    import manager from '../lib/transition/index.js';
    import {onMounted, onUnmounted, ref} from "vue";
    import {addEventListeners} from "@straylightagency/utils/dom";

    const el = ref();

    let events;

    onMounted( () => {
        manager.addLink( el.value );

        events = addEventListeners( el.value, {
            mouseover: async event => manager.handleMouseover( event ),
            click: async event => manager.handleClick( event ),
        } );
    } );

    onUnmounted( () => {
        manager.removeLink( el.value );

        if ( events ) {
            events.click();
            events.mouseover();
        }
    } );
</script>

<template>
    <a ref="el"><slot></slot></a>
</template>